export const PreQualifierAssetTypeSelectionErrorViewStyles = {
  container: 'flex flex-row justify-center text-center',
}
